import { useTranslation } from 'react-i18next';
import { useGetDrupalCustomConfig } from '../../../../hooks/useGetDrupalCustomConfig';

// looks on [breed:species] and [breed:breed] and replaces [breed:species] with species and [breed:breed] with breed
const formatBreedTitle = (unformattedTitle: string, species: string, breed: string) => {
  return unformattedTitle.replace(/\[breed:species\]/g, species).replace(/\[breed:breed\]/g, breed);
};

const formatBreedRelatedTitle = (unformattedTitle: string, breed: string) => {
  return unformattedTitle.replace(/\[breed:breed\]/g, `<strong>${breed}</strong>`);
};

export const useGetBreedCustomInfo = ({ breed, species }: { species: string; breed: string }) => {
  const customConfig = useGetDrupalCustomConfig();
  const { i18n } = useTranslation();

  if (!customConfig?.node__breed || !breed || !species) {
    return { relatedProductTitle: '', relatedBreedTitle: '' };
  }

  const { node__breed } = customConfig;

  const activeLanguage = i18n.language as 'en' | 'es';

  const unformattedProductTitle = node__breed.related_product_section_title[activeLanguage];
  const unformattedBreedTitle = node__breed.tags_section_title[activeLanguage];

  return {
    relatedProductTitle: formatBreedTitle(unformattedProductTitle ?? '', species, breed),
    relatedBreedTitle: formatBreedRelatedTitle(unformattedBreedTitle ?? '', breed),
  };
};
